import Dexie from 'dexie';

const db = new Dexie('NurseryIrrigationTracker');

// Original schema versions — must be preserved for existing databases to upgrade correctly
db.version(1).stores({
  plants: 'id, gridRow, gridCol, commonName, scientificName',
  logEntries: 'id, plantId, timestamp',
  photos: 'id',
  gridConfig: 'id'
});

db.version(2).stores({
  plants: 'id, gridRow, gridCol, commonName, scientificName',
  logEntries: 'id, plantId, timestamp',
  photos: 'id',
  gridConfig: 'id',
  plantSpecies: 'id, commonName, scientificName',
  syncConfig: 'id',
  pendingChanges: '++seq, table, recordId, operation, timestamp',
});

db.version(3).stores({
  plants: 'id, speciesId, gridRow, gridCol',
  logEntries: 'id, plantId, timestamp',
  photos: 'id',
  gridConfig: 'id',
  plantSpecies: 'id, commonName, scientificName',
  syncConfig: 'id',
  pendingChanges: '++seq, table, recordId, operation, timestamp',
});

// Version 4: Remove shared tables (now in SharedPlantTracker via @monorepo/shared)
// Setting to null tells Dexie to drop these tables without destroying the database
db.version(4).stores({
  plants: 'id, speciesId, gridRow, gridCol',
  logEntries: 'id, plantId, timestamp',
  photos: 'id',
  gridConfig: 'id',
  plantSpecies: null,
  syncConfig: null,
  pendingChanges: null,
});

// Version 5: Add identifications table for PlantNet ID history
db.version(5).stores({
  plants: 'id, speciesId, gridRow, gridCol',
  logEntries: 'id, plantId, timestamp',
  photos: 'id',
  gridConfig: 'id',
  identifications: 'id, timestamp',
});

export default db;
